import {NgModule} from '@angular/core';

import {MzMediaService} from './media.service';

@NgModule({
  providers: [MzMediaService],
})
export class MzMediaModule {
}
